import React, { FC } from 'react';

export const IconDoubleCheck: FC<React.PropsWithChildren<{ className?: string }>> = ({ className = '' }) => (
  <svg className={className} width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.61765 6.22727L8.32353 9.5L14.5 0.5M1 6.22727L5.11765 9.5M7.08824 6.22727L11.2059 0.5" stroke="currentColor" />
  </svg>
);
